export default __webpack_public_path__ + "static/media/EM0333.34I-41691_-24993_0.40b4c063.jpg";